import React from 'react';

const BackgroundFull = ({ extraClassName, backgroundImage }) => (
  <div
    className={`promos promos-background-full ${extraClassName? extraClassName : ''}`}
    style={{ backgroundImage }}
  />
);

export default BackgroundFull;
